require('./bootstrap');

import { Jobs } from './components/jobs';
import JobsPhotoGrid from "./components/jobs-photo-grid";
import CitySelectorModal  from './components/city-selector-modal';
import Tariff from "./components/tariff";
import { dynamicMask } from './components/phone-mask';
import Services from "./components/services";
import Documents from "./components/documents";

import ButtonHandler from "./components/button-handler";
import ModalHandler from "./components/modal-handler";
import UtmSetter from "././lib/utm-setter"
import CityCheck from './components/city-check';

import MainSlider from "./components/main-slider"; // bug
import About from "./components/about"; // bug
import Popovers from "./components/popovers"; // bug
import MobileApp from './components/mobile-app';

import Franchise from './components/franchise';

import FooterMenu from "./components/footer-menu";

import SomeStuff from "./components/some-stuff";
import Tab from "bootstrap/js/src/tab";

const jobs = new Jobs(); // vanilla
const jobsPhotoGrid = new JobsPhotoGrid(); // vanilla

const citySelector = new CitySelectorModal(); // vanilla
const services = new Services(); // vanilla
const tariff = new Tariff(); // vanilla
const documents = new Documents() // vanilla
const buttonHandler = new ButtonHandler(); // vanilla
const modalHandler = new ModalHandler(); // vanilla
const cityCheck = new CityCheck(); // vanilla // vanilla
const franchise = new Franchise(); // vanilla // vanilla

const mainSlider = new MainSlider(); // bug  // vanilla
const about = new About(); // bug // vanilla
const popovers = new Popovers(); // bug // vanilla
const footer = new FooterMenu(); // vanilla
const mobileApp = new MobileApp(); // vanilla
const someStuff = new SomeStuff(); // vanilla


